
<template>
  <div>
    <v-card
      outlined
      :disabled="cargando"
      :loading="cargando"
    >
      <v-tabs
        background-color="accent"
        active-class="secondary"
        fixed-tabs
        show-arrows
        v-model="tab"
      >
        <v-tab
          v-for="(status,idxstatus) in estatus"
          :key="idxstatus"
          v-text="_doCustomText(status)"
          :to="ruta+status"
        />
      </v-tabs>
      <div v-if="status!='abono'">
        <v-data-table
          class="upper"
          :headers="headers"
          :items="cargos"
          :loading="cargando"
          loading-text="Cargando..."
        >
          <template v-slot:item.fecha_cgo="{ item }">
            {{_doDiaMesHoras(item.fecha_cgo)}}
          </template>
          <template v-slot:item.importe_cgo="{ item }">
            {{$nF(item.importe_cgo)}}
          </template>
          <template v-slot:item.pendiente_cgo="{ item }">
            {{$nF(item.pendiente_cgo)}}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              icon
              @click="_getCargoDetalle(item.id)"
            >
              <v-icon>visibility</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </div>
      <div v-else>
        <v-data-table
          class="upper"
          :headers="headersAbono"
          :items="abonos"
          :loading="cargando"
          loading-text="Cargando..."
        >
          <template v-slot:item.fecha_abo="{ item }">
            {{_doDiaMesHoras(item.fecha_abo)}}
          </template>
          <template v-slot:item.importe_abo="{ item }">
            {{$nF(item.importe_abo)}}
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-dialog
      v-model="showDialogCargoDetalle"
      scrollable
      width="400"
    >
      <v-card
        :loading="cargando"
        :disabled="cargando"
      >
        <v-card-title>Información del cargo</v-card-title>
        <v-list>
          <v-subheader v-text="'Productos y servicios del cargo'" />
          <div
            v-for="ser in cargo.servicios"
            :key="ser.id_cse"
          >
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title v-text="$nF(parseFloat(ser.precio_cse * ser.cantidad_cse))+', '+ser.desc_ser" />
                <v-list-item-subtitle v-text="'Cantidad: '+ser.cantidad_cse" />
              </v-list-item-content>
            </v-list-item>
            <v-divider />
          </div>
        </v-list>
        <v-list v-if="'abonos' in cargo && cargo.abonos.length>=1">
          <v-subheader>Abonos registrados al cargo</v-subheader>
          <div
            v-for="abc in cargo.abonos"
            :key="abc.id_abc"
          >
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title v-text="'Abono por '+$nF(abc.importe_abo)" />
                <v-list-item-subtitle v-text="_doDiaMesHoras(abc.fecha_abo)" />
                <v-list-item-subtitle v-text="'Método de pago: '+abc.metodo_pago_abo" />
              </v-list-item-content>
            </v-list-item>
            <v-divider />
          </div>
        </v-list>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            v-text="'Cerrar'"
            @click="showDialogCargoDetalle=false"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import forms from "@/mixins/forms.js";
import dates from "@/mixins/dates.js";
export default {
  components: {},
  name: "PacientesDetallesPagos",
  props: {
    id: [String, Number],
  },
  mixins: [forms, dates],
  data() {
    return {
      tab: null,
      status: "incompleto",
      estatus: ["incompleto", "abono", "completo", "cancelado"],
      search: "",
      headers: [
        { text: "Folio", value: "id_cgo", align: "end" },
        { text: "Desde", value: "fecha_cgo" },
        { text: "Importe", value: "importe_cgo", align: "end" },
        { text: "Debe", value: "pendiente_cgo", align: "end" },
        { text: "", value: "actions", align: "end" },
      ],
      headersAbono: [
        { text: "Fecha", value: "fecha_abo" },
        { text: "Importe", value: "importe_abo", align: "end" },
        { text: "Metodo", value: "metodo_pago_abo", align: "end" },
      ],
      cargos: [],
      saldos: [],
      cargo: {},
      abonos: [],
      showDialogCargoDetalle: false,
      ruta: null,
    };
  },
  methods: {
    async _getCargos(res = null) {
      if (res && "msg" in res) {
        this.$emit("msg", res.msg);
      }
      this.cargando = true;
      try {
        const {
          status,
          body: { cargos, saldos },
        } = await this.$http.get(
          "cargos/paciente/" + this.id + "?estatus=" + this.status,
          this.$headers
        );
        this.cargando = false;
        this.cargos = cargos;
        this.saldos = saldos;
        this.search = "";
      } catch (err) {
        this.cargando = false;
        this.$emit("httpError", err);
      }
    },
    _getAbonos() {
      this.abonos = [];
      this._getThings("abonos/paciente/" + this.id, "abonos");
    },
    async _getCargoDetalle(idCgo) {
      this.cargando = true;
      try {
        const {
          body: { cargo },
        } = await this.$http.get("cargos/detalle/" + idCgo, this.$headers);
        this.cargando = false;
        if (cargo) {
          this.cargo = cargo;
          this.showDialogCargoDetalle = true;
        } else {
          this.$emit("error", body.error);
        }
      } catch (err) {
        this._handleError(err);
      }
    },
    _doCustomText(text = "") {
      switch (text) {
        case "incompleto":
          return "deuda";
          break;
        case "completo":
          return "liquidado";
          break;
        case "cancelado":
          return "cancelado";
          break;
        case "abono":
          return "abono";
          break;
        default:
          return "";
          break;
      }
    },
  },
  created() {
    // Obtener el estatus de la ruta si existe
    const routeStatus = this.$route.params.estatus;
    if (routeStatus) {
      this.status = routeStatus;
    }
    this.ruta = "/paciente/historiaclinica/" + this.id + "/pagos/";
  },
  mounted() {
    this._getCargos();
  },
  watch: {
    "$route.params.estatus"(a) {
      this.cargos = [];
      this.abonos = [];
      this.status = a;
      a == "abono" || a == "abonos" ? this._getAbonos() : this._getCargos();
    },
    showDialogCargoDetalle(a) {
      if (!a) this.cargo = {};
    },
    id() {
      this.ruta = "/paciente/historiaclinica/" + this.id + "/pagos/";
      const routeStatus = this.$route.params.estatus;
      if (routeStatus) {
        this.status = routeStatus;
      }
      this._getCargos();
    },
  },
};
</script>

